/* @jsxImportSource react */

import { Image } from '@packages/shared/src/ui/Image/Image';
import type { SelectValuesFragmentFragment } from '@packages/gql/generated/shopping/graphql';

const SIZEBUTTON = 24;
const SIZEDIALOG = 36;

export type VariationIconProps = {
  /**
   * the data needed to render the component
   */
  data: Pick<
    SelectValuesFragmentFragment['values'][number],
    'image' | 'variationMainImage' | 'rgb'
  >;
  /**
   * render mode of the component
   */
  mode: 'BUTTON' | 'DIALOG';
};

/**
 * The `VariationIcon` conponent is used to display an image for the selected dimension,
 * either for the `VariationRow` inside as part of the dialog or in the `SelectionDimension` as a button
 * */
export const VariationIcon = ({ data, mode }: VariationIconProps) => {
  const { rgb, image, variationMainImage } = data;

  const IMAGESIZE = mode === 'BUTTON' ? SIZEBUTTON : SIZEDIALOG;
  const imageSrc = image || variationMainImage;

  return (
    /* must be an inline element because it will used in a button */
    <span
      className="border-color-grey shrink-0 grow-0 overflow-hidden rounded-full border"
      style={{
        width: `${IMAGESIZE}px`,
        height: `${IMAGESIZE}px`,
        backgroundColor: rgb ? `#${rgb}` : 'none',
      }}
    >
      {imageSrc && (
        <Image role="presentation" src={imageSrc} alt="" width={IMAGESIZE} height={IMAGESIZE} />
      )}
    </span>
  );
};
